import React from 'react'
import Banks_SVG from '../../../../../assets/svg/svg_banks'
import { banks } from '../../../../../utils/bankList'
import { Dropdown } from 'semantic-ui-react'
import './style.scss'

const BankSelection = ({
  style = {},
  onChange = () => { },
  onBlur = () => { },
  className = 'bankSelectionDropdown',
  placeholder = 'Banco...',
  id = 'bankId',
  name = 'bankId',
  selection = true,
  multiple = false,
  clearable = false,
  value = null,
  defaultValue = null,
  filter = f => f,
  disabled = false
}) => {

  const BankList = banks
    .filter(filter)
    .map(f => {
      return ({
        text: f.label,
        value: f.value,
        key: f.value,
        image: { avatar: true, src: Banks_SVG(f.value) }
      })
    })

  if (value) {
    return (
      <Dropdown
        selectOnBlur={false}
        className={`${className} tw-h-[35px]`}
        selection={selection}
        multiple={multiple}
        style={{ ...style }}
        placeholder={placeholder}
        id={id}
        name={name}
        value={value}
        options={BankList}
        onChange={onChange}
        onBlur={onBlur}
        clearable={clearable}
        disabled={disabled}
        fluid
      />
    )
  }

  return (
    <Dropdown
      selectOnBlur={false}
      className={className}
      selection={selection}
      multiple={multiple}
      style={{ ...style }}
      placeholder={placeholder}
      id={id}
      name={name}
      defaultValue={defaultValue}
      options={BankList}
      onChange={onChange}
      onBlur={onBlur}
      clearable={clearable}
      disabled={disabled}
      fluid
    />
  )
}

export default BankSelection